import React from 'react';
import styles from './index.module.less';
import { HeaderContext, headerNavList, hideCloudCountryList, showLiveCountryList } from '../../common';
import CompNavItem from './CompNavItem';
import CompProductNavItem from './ProductNavItem';
import { ReoIcon } from '@reolink-web/components.basic';
import classNames from 'classnames';
import CompCountryLangNavItem from './CountryLangNavItem';
import CompAccountNavItem from './AccountNavItem';

const CompHeaderNav: React.FC = React.memo(() => {
    const { userPrefile, country } = React.useContext(HeaderContext);

    const [showMobileMenu, setShowMobileMenu] = React.useState<boolean>(false);

    const [showSubMenuKey, setShowSubMenuKey] = React.useState<number | string>();

    const handleShowMenuClick = React.useCallback(() => {
        if (showMobileMenu) {
            document.documentElement.classList.remove(styles['ban-scroll']);
            document.body.classList.remove(styles['ban-scroll']);
            setShowMobileMenu(false);
        }
        else {
            document.documentElement.classList.add(styles['ban-scroll']);
            document.body.classList.add(styles['ban-scroll']);
            setShowMobileMenu(true);
        }
    }, [showMobileMenu]);

    const handleNavItemClick = React.useCallback(
        (index: number | string) => {
            if (showSubMenuKey === index) {
                setShowSubMenuKey(undefined);
            }
            else {
                setShowSubMenuKey(index);
            }
        },
        [showSubMenuKey],
    );

    const navList = React.useMemo(() => {
        // 代理商不显示限时折扣
        return headerNavList
            .filter((item) => {
                if (hideCloudCountryList.includes(country) && item.title === 'nav-cloud') {
                    return false;
                }
                return true;
            })
            .map((item) => {
                if (item.title === 'nav-deals') {
                    return {
                        ...item,
                        badge: !userPrefile?.distributor,
                        menus: item.menus?.filter((menu) => {
                            if (userPrefile?.distributor && menu.title === 'menu-flash-sale') {
                                return false;
                            }

                            if (!showLiveCountryList.includes(country) && menu.title === 'menu-reolink-live') {
                                return false;
                            }
                            return true;
                        }),
                    };
                }
                return item;
            }, []);
    }, [country, userPrefile?.distributor]);

    return (
        <>
            <div
                className={ classNames(styles['menu-container'], {
                    [styles['show-mobile-menu']]: showMobileMenu,
                }) }
            >
                <ul className={ classNames(styles['menu']) }>
                    <CompProductNavItem
                        onTitleClick={ () => {
                            handleNavItemClick('products');
                        } }
                        isShowSubMenu={ showSubMenuKey === 'products' }
                    />
                    {navList.map((item, index) => {
                        return (
                            <CompNavItem
                                key={ item.title }
                                { ...item }
                                isShowSubMenu={ showSubMenuKey === index }
                                onTitleClick={ () => {
                                    handleNavItemClick(index);
                                } }
                            />
                        );
                    })}
                    <CompCountryLangNavItem />
                </ul>
                <CompAccountNavItem />
            </div>
            <div
                className={ styles['show-menu-button'] }
                onClick={ handleShowMenuClick }>
                <ReoIcon
                    name={ showMobileMenu ? 'icon-cross2' : 'icon-icon_caidan' }
                    className={ styles['show-menu-icon'] }
                />
            </div>
        </>
    );
});
export default CompHeaderNav;
